<template>
  <div class="h-100 pp-list">
    <!-- Toolbar with Search and Filters -->
    <div class="row m-0 px-2">
      <div class="col-12 col-xl form-group m-0 p-0">
        <b-form @submit.prevent="handleSearch" class="row m-0">
          <!-- Search Input -->
          <div class="form-group pl-md-0 col-12 col-md-4 col-lg-3 col-xl-2">
            <input
              type="text"
              class="form-control form-control-sm form-control-muted"
              v-model="searchText"
              :placeholder="$t('common.search')"
              aria-label="Search"
            />
          </div>

          <!-- Action Buttons -->
          <div class="col-auto form-group pl-md-0">
            <button type="submit" title="search" class="btn p-0 text-body">
              <span class="material-symbols-outlined fs-22 p-1">search</span>
            </button>
            <button
              title="All Clear"
              class="btn p-0 text-body"
              @click="clearFilters"
            >
              <span class="material-symbols-outlined fs-22 p-1"
                >filter_alt_off</span
              >
            </button>
          </div>
        </b-form>
      </div>
    </div>

    <!-- Content Slot -->
    <div class="container-fluid p-0 position-relative">
      <div class="position-absolute w-100">
        <wtr-loader
          v-if="showLoader"
          containerClass="align-items-center d-flex fs-18 justify-content-center"
          containerStyle="column-gap: 5px;"
          addText
          variant="primary"
        ></wtr-loader>
      </div>

      <div
        v-if="list && list.length > 0"
        class="h-100"
        :class="{ 'fetch-class': showLoader }"
      >
        <transition name="fade" mode="out-in">
          <!-- List View -->
          <div key="listMode">
            <slot name="list-table"></slot>
          </div>
        </transition>
      </div>
    </div>
    <no-data-found
      :message="emptyListMessage"
      v-if="!list || list.length === 0"
    ></no-data-found>

    <div
      v-if="showPagination && list && list.length > 0"
      class="row m-0 mt-5 align-items-center px-2"
      style="row-gap: 10px"
    >
      <div class="col-auto px-md-0">
        <select
          aria-label="Change Size"
          @change="changeSize(Number($event.target.value))"
          class="form-control form-control-sm form-control-muted"
          style="width: 200px"
        >
          <option :value="null" selected class="fs-14">
            {{ $t("common.perPage") }}
          </option>
          <option
            class="fs-14"
            :value="item"
            v-for="(item, index) in totalElements"
            :key="index"
            :selected="params.size === item"
          >
            {{ item }}
          </option>
        </select>
      </div>

      <div class="col-auto">
        <b-pagination
          size="sm"
          pills
          @change="pageChange"
          class="m-0"
          :value="params.page + 1"
          :limit="3"
          :per-page="params.size"
          :total-rows="options.totalElements"
        ></b-pagination>
      </div>

      <div class="col-auto" v-if="options.totalElements > 1000">
        <div class="info-text">
          <i class="fa fa-info-circle"></i>
          {{ $t("notes.maximumOf1000Records") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import noDataFound from "./no-data-found.vue";
import * as roleTypes from "../../constants/constants-role";

export default {
  name: "wtr-assigned-users-list",
  components: {
    "no-data-found": noDataFound,
  },
  props: {
    list: Array,
    options: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    showLoader: Boolean,
    emptyListMessage: {
      type: String,
      default: () => "No data found",
    }
  },
  computed: {
    showPagination() {
      return this.options.pagination;
    },
    totalElements() {
      if (!this.options.totalElements) return [];
      const percentile = this.options.totalElements > 100 ? 10 : 5;
      const diff = this.options.totalElements % percentile;
      let total = this.options.totalElements + (percentile - diff);
      total = total > 1000 ? 1000 : total;
      let x = percentile;
      const arr = [];
      while (x <= total) {
        arr.push(x);
        x += percentile;
      }
      return arr;
    },
  },
  data() {
    return {
      ...roleTypes,
      searchText: "",
      selectedSubFilter: [],
      
      
    };
  },
  methods: {
    handleSearch() {
      const filters = {};

      // Add search text if present
      if (this.searchText.trim()) {
        filters.search = this.searchText.trim();
      }

      this.configSubFilters.forEach((config, index) => {
        if (
          this.selectedSubFilter[index] !== null &&
          this.selectedSubFilter[index] !== undefined
        ) {
          filters[config.searchParam] = this.selectedSubFilter[index].id;
        }
      });

      this.$emit("filter-change", filters);
    },
    clearFilters() {
      this.searchText = "";
      this.selectedSubFilter = [];
      this.$emit("filter-change", {});
    },
    changeSize(size) {
      const params = { ...this.params };
      params.size = size > 1000 ? 1000 : size;
      this.$emit("size-change", params);
    },
    pageChange(page) {
      const params = { ...this.params };
      params.page = page - 1; // Convert to zero-based index
      this.$emit("page-change", params);
    },
  },
};
</script>